import styled from 'styled-components';
import { MessagePreview } from '@sdk/components/messages/MessagePreview/MessagePreview';

import { Message } from '@web/conversations/types/Message';

import { Button, CloseIcon } from './quotedMessagePreview.styles';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.bodyBg};
  padding: 5px 20px 10px 10px;
`;

type Props = {
  quotedMessage: Message;
  removeQuotedMessage: () => void;
};

// @TODO remove this file completely when we move conversation to react
const QuotedMessagePreviewAngular = ({ quotedMessage, removeQuotedMessage }: Props) => {
  return quotedMessage ? (
    <Wrapper>
      <MessagePreview message={quotedMessage as any} />

      <Button onClick={removeQuotedMessage}>
        <CloseIcon />
      </Button>
    </Wrapper>
  ) : null;
};

export default QuotedMessagePreviewAngular;
